module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_demichele_sm-6f34ec66c5765d17138fd70b08e79278.png";